<p-dialog
  header="Upload planilha presença"
  [(visible)]="visible"
  [style]="{
    width: '50rem',
    height: '30rem',
  }"
  [draggable]="false"
  (onHide)="this.inputClose.emit(true)"
>
  <div class="container">
    <h3>Selecione o mês e ano do qual deseja enviar a lista de presença</h3>
    <form #pessoa="ngForm">
      <div class="form-group">
        <app-input type="text" style="display: none"></app-input>
        <app-input
          label="Mês:"
          type="select"
          name="mes"
          [requiredInput]="true"
          [selectData]="mesOptions"
          [(ngModel)]="this.form.mes"
        ></app-input>
        <app-input
          label="Ano:"
          type="select"
          name="ano"
          [requiredInput]="true"
          [selectData]="anoOptions"
          [(ngModel)]="this.form.ano"
        ></app-input>
      </div>
      <app-botao
        type="upload"
        text="Selecionar lista de presença"
        (fileSelected)="uploadArquivo($event)"
        [disabled]="validarForm() ? false : true"
      ></app-botao>
    </form>
  </div>
</p-dialog>

<div *ngIf="visible" class="blur-overlay"></div>
<app-loader *ngIf="loader" />
